import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//

import { isExternal } from '@/utils/validate';
import { createBizPath } from '@/utils/routeHelper';
export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    linkProps: function linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        };
      }

      // 使用路由辅助函数处理路径
      var processedUrl = url.includes('/biz/') ? url : createBizPath(url);
      return {
        is: 'router-link',
        to: processedUrl
      };
    }
  }
};